import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { BrandingService } from './app/core/services/branding';

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    const branding = appRef.injector.get(BrandingService);
    void branding.load();
  })
  .catch((err) => console.error(err));
